
import { FundStatus } from '@common/enums';


import { EnvironmentDisease } from './environment-disease';

export interface Disease {
  readonly id: number;
  typeId?: number;
  name?: string;
  state?: string;
  fundStatuses?: FundStatus[];
  environmentDiseases?: EnvironmentDisease[];
  color?: string;
  allFoundations?: string;
  environmentFundsCount?: string;
  environmentFoundationsCount?: string;
  guid?: string;
}
